import type { EnrichedVehicleDetails } from '@web/vin-sessions/types';

import { vinSessionService } from '@web/services/singletons';

/**
 * Look the VIN up in TechShare.
 *
 * @param vin - the VIN to look up
 * @param signal - aborts the lookup
 * @returns the vehicle record, or undefined when TechShare has none for the VIN
 */
export async function findVehicle(vin: string, signal: AbortSignal): Promise<EnrichedVehicleDetails | undefined> {
    const response = await vinSessionService.getVinData({ fetchVinParams: { vin }, ignoreCache: true, signal });

    return response.success ? response.data[0] : undefined;
}
